import { render } from "./ResultsListnew.vue?vue&type=template&id=122dc010&scoped=true"
import script from "./ResultsListnew.vue?vue&type=script&lang=js"
export * from "./ResultsListnew.vue?vue&type=script&lang=js"

import "./ResultsListnew.vue?vue&type=style&index=0&id=122dc010&lang=scss"
import "./ResultsListnew.vue?vue&type=style&index=1&id=122dc010&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2682924403/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122dc010"]])

export default __exports__